import { createFileRoute } from "@tanstack/react-router";

import { MembersPage } from "../iam/organization/components/MembersPage";

/**
 * Route is /organizations/$organizationId/members: the members page, the default
 * organization landing. Open to every role (the page itself gates the invite +
 * manage controls on the acting user's role).
 */
export const Route = createFileRoute("/_app/organizations/$organizationId/members")({
  component: MembersPage,
});
